import { render, staticRenderFns } from "./BCXForm.vue?vue&type=template&id=10e6ebac&scoped=true"
import script from "./BCXForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCXForm.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BCXForm.vue?vue&type=style&index=0&id=10e6ebac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e6ebac",
  null
  
)

export default component.exports